import React from 'react'
import ReactDOM from 'react-dom/client'
import AppShell from '@/shared/components/AppShell'
import PortalApp from './PortalApp'
import '@/shared/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <AppShell>
    <PortalApp />
  </AppShell>
)

